import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './PageNav.css';

// The chain of places from the top down to (and including) startId, from the
// rows returned by GET /api/locations/all.
export function buildTrail(locations, startId) {
  const byId = new Map(locations.map((l) => [l.id, l]));
  const chain = [];
  for (let cur = byId.get(startId); cur && chain.length < 50; cur = byId.get(cur.parentLocationId)) {
    chain.unshift(cur);
  }
  return chain;
}

function Chevron() {
  return (
    <svg className="pagenav-chevron" viewBox="0 0 8 14" aria-hidden="true">
      <path d="M1 1l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// A Back button and a breadcrumb trail. The trail is right-aligned and scrolls sideways
// when it does not fit: it starts scrolled to the nearest level, and dragging it to the
// right reveals the higher levels. Back goes to the previous page, or to `fallback` when
// there is none (for example when the page was opened from a scanned label).
function PageNav({ trail, current, fallback }) {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollLeft = el.scrollWidth;
  }, [trail, current]);

  const goBack = () => {
    const index = window.history.state && window.history.state.idx;
    if (index > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  };

  return (
    <div className="pagenav">
      <button type="button" className="pagenav-back" onClick={goBack}>
        <svg viewBox="0 0 8 14" aria-hidden="true" className="pagenav-back-icon">
          <path d="M7 1L1 7l6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Back
      </button>
      <div className="pagenav-scroll" ref={scrollRef}>
        <nav className="pagenav-trail" aria-label="Breadcrumb">
          <Link to="/locations" className="pagenav-link">🏠 Storage Locations</Link>
          {trail.map((place) => (
            <React.Fragment key={place.id}>
              <Chevron />
              <Link to={`/locations/${place.id}`} className="pagenav-link">{place.name}</Link>
            </React.Fragment>
          ))}
          <Chevron />
          <span className="pagenav-current">{current}</span>
        </nav>
      </div>
    </div>
  );
}

export default PageNav;
